export const MAX_VEHICLES_INSURED = Number(
  process.env.REACT_APP_MAX_VEHICLES_ENSURED,
)

export const MAX_SUM_INSURED = Number(
  process.env.REACT_APP_MAX_GLOBAL_SUM_INSURED,
)

export const MAX_CLAIMS = Number(process.env.REACT_APP_MAX_CLAIMS)

export const MAX_SUM_LOSES = Number(process.env.REACT_APP_MAX_GLOBAL_SUM_LOSES)

export const OFFER_MONTHS_VALIDITY = Number(
  process.env.REACT_APP_OFFER_MONTHS_VALIDITY,
)

export const termsAndConditions = {
  de:
    'https://www.helvetia.com/ch/web/de/ueber-uns/services/kontakt/rechtliche-hinweise.html',
  fr:
    'https://www.helvetia.com/ch/web/fr/notre-profil/services/contact/indications-juridiques-et-regles.html',
  it:
    'https://www.helvetia.com/ch/web/it/ci-presentiamo/servizi/contatti/disposizioni-giuridiche-e-condizioni.html',
  en:
    'https://www.helvetia.com/ch/web/en/about-us/services/contact/legal-info.html',
  es:
    'https://www.helvetia.com/ch/web/en/about-us/services/contact/legal-info.html',
}

export const impressum = {
  de:
    'https://www.helvetia.com/ch/web/de/ueber-uns/services/kontakt/impressum.html',
  fr:
    'https://www.helvetia.com/ch/web/fr/notre-profil/services/contact/impressum.html',
  it:
    'https://www.helvetia.com/ch/web/it/ci-presentiamo/servizi/contatti/impressum.html',
  en:
    'https://www.helvetia.com/ch/web/en/about-us/services/contact/imprint.html',
}

export const legalInfo = {
  de:
    'https://www.helvetia.com/ch/web/de/ueber-uns/services/kontakt/rechtliche-hinweise.html',
  fr:
    'https://www.helvetia.com/ch/web/fr/notre-profil/services/contact/indications-juridiques-et-regles.html',
  it:
    'https://www.helvetia.com/ch/web/it/ci-presentiamo/servizi/contatti/disposizioni-giuridiche-e-condizioni.html',
  en:
    'https://www.helvetia.com/ch/web/en/about-us/services/contact/legal-info.html',
  es:
    'https://www.helvetia.com/ch/web/en/about-us/services/contact/legal-info.html',
}

export const privacyPolicy = {
  de:
    'https://www.helvetia.com/ch/web/de/ueber-uns/services/kontakt/datenschutz.html',
  fr:
    'https://www.helvetia.com/ch/web/fr/notre-profil/services/contact/protection-des-donnees.html',
  it:
    'https://www.helvetia.com/ch/web/it/ci-presentiamo/servizi/contatti/protenzionedeidati.html',
  en:
    'https://www.helvetia.com/ch/web/en/about-us/services/contact/privacy.html',
  es:
    'https://www.helvetia.com/ch/web/en/about-us/services/contact/privacy.html',
}

export const jobs = {
  de:
    'https://www.helvetia.com/ch/web/de/ueber-uns/jobs-und-karriere/offene-stellen.html',
  fr:
    'https://www.helvetia.com/ch/web/fr/notre-profil/jobs-et-carriere/postes-vacants.html',
  it:
    'https://www.helvetia.com/ch/web/it/ci-presentiamo/jobs-e-carriera/posti-vacanti.html',
  en:
    'https://www.helvetia.com/ch/web/en/about-us/jobs-and-career/vacancies.html',
  es:
    'https://www.helvetia.com/ch/web/en/about-us/jobs-and-career/vacancies.html',
}

export const customerPortal = {
  de:
    'https://www.helvetia.com/ch/web/de/services/administration/privatkunden/kundenportal.html',
  fr:
    'https://www.helvetia.com/ch/web/fr/service/administration/personnes-privees/portail-client.html',
  it:
    'https://www.helvetia.com/ch/web/it/servizi/amministrazione/clienti-privati/portale-clienti.html',
  en:
    'https://www.helvetia.com/ch/web/en/services/administration/private-customers/customer-portal.html',
  es:
    'https://www.helvetia.com/ch/web/en/services/administration/private-customers/customer-portal.html',
}

export const helvetiaGroup = {
  de: 'https://www.helvetia.com/corporate/web/de/home.html',
  fr: 'https://www.helvetia.com/corporate/web/fr/home.html',
  it: 'https://www.helvetia.com/corporate/web/it/home.html',
  en: 'https://www.helvetia.com/corporate/web/en/home.html',
  es: 'https://www.helvetia.com/corporate/web/en/home.html',
}

export const helvetiaCloHome = {
  de:
    'https://www.helvetia.com/ch/web/de/geschaeftskunden/transport-und-fahrzeuge/transport/frachtfuehrerhaftpflicht.html',
  fr:
    'https://www.helvetia.com/ch/web/fr/entreprises/transport-et-vehicules/transport/rc-transporteur.html',
  it:
    'https://www.helvetia.com/ch/web/it/clienti-aziendali/trasporto-e-veicoli/trasporto/rc-vettore.html',
  en:
    'https://www.helvetia.com/ch/web/en/corporate-customer/transports-and-vehicles/transports/carriers-liability.html',
  es:
    'https://www.helvetia.com/ch/web/en/corporate-customer/transports-and-vehicles/transports/carriers-liability.html',
}
